/** Homepage / i18n (English) */
export const landingHomeEn = {
  seo: {
    title: 'Veeso AI | Turn Raw Content into Deliverable Designs',
    description:
      'Turn copy into polished designs in one click. Veeso auto-layouts social posts, slides, and pages—fully editable, fast, and accurate. No design skills needed.',
    keywords:
      'AI design, content-first design, social media visuals, SMB marketing, auto layout, visual content tool',
  },
  nav: {
    logo_alt: 'Veeso AI',
    features: 'Features',
    pricing: 'Pricing',
    about: 'About',
    spotlight: 'Spotlight',
    start_free: 'Start Free',
    workspace: 'Workspace',
    toggle_menu_aria: 'Toggle menu',
    close_menu_aria: 'Close menu',
  },
  hero: {
    h1_line1: 'Veeso turns raw copy into',
    h1_line2: 'production-ready designs',
    subtitle: 'Content in, Design out. No prompts. No design skills required.',
    cta_mobile: 'Start Free',
    flying_card_alt: 'Veeso Design',
    file_type: {
      doc: 'DOC',
      xls: 'XLS',
      ppt: 'PPT',
      pdf: 'PDF',
      img: 'IMG',
      txt: 'TXT',
      md: 'MD',
    },
    flying_text: [
      'Create stunning social media posts with AI-powered design tools',
      'Transform your ideas into beautiful visuals in minutes',
      'Professional design made simple',
      'AI-powered creativity',
      'Design faster, smarter',
      'From concept to creation',
      'Unleash your creativity with AI assistance',
      'Beautiful designs in seconds',
      'No design skills required',
      'Your vision, our AI',
      '1080 × 1920',
      '16:9 Ratio',
      '4K Resolution',
      'Instagram Ready',
    ],
  },
  hero_prompt: {
    placeholder: 'Describe what you want to design',
    btn_design: 'Design',
    btn_designing: 'Designing...',
  },
  every_scene: {
    eyebrow: 'Veeso AI',
    heading_line1: 'Not Image Generation',
    heading_line2: 'Generate Production-Ready Designs',
    cta_header: 'Design now',
    scene: {
      ecommerce: 'e-Commerce',
      edm: 'EDM',
      hiring: 'Hiring Post',
      travel: 'Travel road book',
      academic: 'Academic',
      restaurant: 'Restaurant',
      event_promo: 'Event Promo',
      brand: 'Brand Identity',
      product_launch: 'Product Launch',
      infographic: 'Infographic',
      campaign: 'Ad Campaign',
      presentation: 'Presentation',
      marketing_deck: 'Marketing Deck',
      pitch_deck: 'Pitch Deck',
    },
    cta_card: {
      design_more: 'DESIGN\nMORE',
      content_in_out: 'CONTENT IN\nDESIGN OUT',
      with_veeso_now_line1: 'WITH',
      with_veeso_now_line2: 'VEESO',
      with_veeso_now_line3: 'NOW',
      link: 'Design Now',
    },
  },
  every_step: {
    section_heading_line1: 'Design at the',
    section_heading_line2: 'speed of thought',
    panel01: {
      label: '01 Generate',
      title: 'Stop searching templates.',
      body: 'Paste content, Veeso AI will generate designs for you and keep every word you wrote with nice typography and layout.',
      cta: 'Design now',
    },
    panel02: {
      label: '02 Edit',
      title: 'Not images. Edit text directly',
      body: 'Edit text directly in the design. Stop wasting time on image editing.',
      cta: 'Design now',
    },
    panel03: {
      label: '03 Deliver',
      title: 'Export in all formats.',
      body: 'Export your designs as high-quality images, PDFs, or share directly to social media with one click.',
      cta: 'Design now',
    },
    more_explore_heading: 'Also you can edit images in Veeso AI',
  },
  cards: {
    text_edit: {
      typewriter: {
        en_edit: 'edit',
        en_text: 'text',
      },
    },
    remove_bg: {
      primary: 'Background Removal.',
      secondary: 'Precise removal for products, portraits, and complex scenes.',
    },
    upscale: {
      primary: 'HD Upscaling.',
      secondary: 'Enhance resolution up to 4x with AI detail restoration.',
    },
    image_styles: {
      primary: 'Multiple Image Styles.',
      secondary: 'Transform any image with 15+ AI styles in one click.',
      painting: 'PAINTING',
      realistic: 'REALISTIC',
      natural: 'NATURAL',
      cyberpunk: 'CYBERPUNK',
      neon: 'NEON',
      futuristic: 'FUTURISTIC',
      magic: 'MAGIC',
      '3d_surrealism': '3D SURREALISM',
      line_art: 'LINE ART',
      webcomic: 'WEBCOMIC',
      narrative_comic: 'NARRATIVE COMIC',
      neo_folk_pop: 'NEO-FOLK POP',
      halftone: 'HALFTONE',
      old_halftone: 'OLD HALFTONE',
      surreal_arch: 'SURREAL ARCH',
    },
    deliver: {
      report: 'Report',
      social_post: 'Social Post',
      ppt_deck: 'PPT / Deck',
      newsletter: 'Newsletter',
      print: 'Print',
      banner: 'Banner',
    },
  },
  mock: {
    user_message:
      'Create a waiting list poster for Veeso AI product launch, 1:1 ratio for Instagram, with celebration vibes',
    ai_intro: "Great! Let's create a waiting list poster. Here's the design brief:",
    steps: {
      background: 'Pastel gradient background',
      typography: 'Bold typography hierarchy',
      ratio: '1:1 square for social media',
      imagery: 'Celebratory imagery',
    },
    section: {
      design_concept_label: 'Design concept',
      design_concept_content:
        'A celebratory waiting list announcement featuring bold rank number (#521,314) as the hero element. Soft pastel gradient creates warmth while the firework imagery adds excitement. Typography uses strong contrast between headline and supporting text.',
      theme_label: 'Theme',
      theme_value: 'Celebratory',
      image_style_label: 'Image style',
      image_style_value: 'Festive',
      ratio_label: 'Ratio',
      ratio_value: '1:1',
    },
    canvas: {
      untitled_design: 'Untitled Design',
      composer_placeholder: 'Want to try? Type something...',
      share_button: 'Share',
      share_text:
        'I founded a very cool AI design tool, which can help to turn your content into design in minutes.',
      copy_link: 'Copy link',
      share_to: 'Share to',
      collapse_sidebar: 'Collapse sidebar',
      expand_sidebar: 'Expand sidebar',
      generating: 'Generating...',
      frame_label: 'Frame 1',
    },
    auth: {
      prompt: 'Now just Sign in or Sign up to design better, fast.',
      sign_in: 'Sign in',
      sign_up: 'Sign up',
    },
    poster: {
      title_line1: 'Welcome to',
      title_line2: 'Veeso AI',
      title_line3: "You're the",
      name: 'ROKI\nWANG',
      feature1: 'Anyone can\ndesign with\nveeso AI',
      feature2: "We're good\nat designing\ngraphic",
      feature3: 'Long-Scroll\nInfographic\nSales emails',
      feature4: 'Decks\nSlides\nBrochures',
      number: '#521,314\nON THE\nLIST.',
      image_alt: 'Design',
      brand: 'Veeso',
    },
  },
  testimonials: {
    1: {
      content:
        'Veeso has completely transformed how we create social media content. Now all the materials in our social media are created in Veeso AI. Before that, I have to find a designer to create the materials, which is time-consuming and expensive.',
      name: 'Sarah Lee',
      role: 'Marketing Manager',
    },
    2: {
      content:
        'As a non-designer, I was amazed at how quickly I could create professional-looking presentations and posts. A lot of long form posts for my customers are designed in Veeso AI, you can just paste your content and it will be automatically designed.',
      name: 'Marcus Johnson',
      role: 'Founder',
    },
    3: {
      content:
        'As a content creator, the most important thing is the differentiation. The AI understands exactly what I need and designed in my style, which helps a lot in the competition.',
      name: 'Emily Rodriguez',
      role: 'Content Creator',
    },
    4: {
      content:
        'After building our products, we need a lot of materials to promote our products in social media with different formats and sizes. Veeso AI is a great tool for us to create them all in a canvas with just typing what you want. The consistency and quality are unmatched.',
      name: 'David Kim',
      role: 'Product Manager',
    },
    5: {
      content:
        'We have a lot of social media accounts in different platforms. On brand material is very important for us. Now what I just upload the design materials and copy, it will designed the same style with the same voice and brand identity.',
      name: 'Lisa Thompson',
      role: 'Social Media Lead',
    },
    6: {
      content:
        'We are a small team selling products in different platforms in different countries. Creating product details page and posters with different languages is a big challenge. Now we just paste the content and it will be automatically designed in different languages.',
      name: 'Alex Wang',
      role: 'E-commerce Owner',
    },
    heading_line1: 'Designed for everyone',
    heading_line2: 'Enjoyed by everyone',
    subheading:
      'Veeso AI users can now design like a pro and achieve better ROI by creating stronger results with less time and budget.',
  },
  faq: {
    1: {
      question: 'What is Veeso AI?',
      answer_p1:
        'For SMB owners, marketers, operations, founders with limited design resources and tight deadlines, producing professional visuals is slow and expensive.',
      answer_p2:
        'Veeso is a content-first design tool that turns copywriting into clear, polished visuals in one click, one minute, no design skills required.',
      answer_p3: 'Just paste your content or text, and instantly generate beautiful designs for',
      product: [
        'Social Media Post',
        'Poster',
        'Presentation',
        'Carousel',
        'Multi-Page Brochure',
        'Long-Form Content',
        'Restaurant Menu',
        'Invitation Card',
        'Pull Up Banner',
        'Flyer',
        'Album Cover',
      ],
    },
    2: {
      question: 'How is Veeso different from AI image generation tools?',
      answer_p1:
        'Most AI design tools generate images. Veeso generates complete, editable design files with:',
      list: [
        'Editable text blocks',
        'Logical content hierarchy',
        'Multi-page formatting',
        'Export-ready designs',
      ],
    },
    3: {
      question: 'Who is Veeso AI built for?',
      answer:
        'Veeso is designed for creators, solo founders, marketers, and small to mid-sized businesses (SMBs) who need professional designs without hiring a designer or spending hours formatting content.',
    },
    4: {
      question: 'What is the core Content-First philosophy?',
      answer_p1:
        'Content-First means design starts from your information — not from templates or images. Instead of searching for fixed templates and forcing content into them, Veeso analyzes your raw text and automatically structures it into clear sections, headlines, and visual hierarchy. We believe your content should not be locked inside:',
      list_a: ['A specific slide layout', 'A rigid template', 'A single platform format'],
      answer_p2:
        'Veeso decouples content from format, allowing the same input to be transformed into:',
      list_b: ['Presentations', 'Newsletters', 'Social posts', 'Reports', 'Brochures'],
      answer_p3: 'One source of content. Multiple design outputs.',
    },
    5: {
      question: 'What is considered "content" in Veeso?',
      answer:
        'In Veeso, content refers to any material that communicates a message — including draft text, bullet points, blog articles, investor notes, product descriptions, social copy, reports, images, references, etc. Anything that conveys information can be transformed into structured design output.',
    },
    6: {
      question: 'What is the Magic Template?',
      answer_p1:
        "Magic Template is Veeso AI's style control system. Instead of fixed, static templates, Magic Template dynamically adapts layout structure based on:",
      list: ['Content length', 'Information hierarchy', 'Tone and intent', 'Output format'],
      answer_p2:
        'It intelligently arranges sections, headlines, visuals, and spacing to create professional design files without manual formatting.',
    },
    7: {
      question: 'What kinds of files can I create with Veeso?',
      answer:
        'You can create presentations, newsletters, social media posts, reports, one-pagers, brochures, and long-form content pages, etc. All are generated from your original text input.',
    },
    8: {
      question: 'Can I edit the designs after they are generated?',
      answer:
        'Yes. Every output is fully editable. You can adjust text, layout, images, structure, and branding elements directly inside Veeso before exporting.',
    },
    9: {
      question: 'Can I use my own branding in Veeso?',
      answer:
        'Yes. You can apply your own brand styles, colors, and layouts to ensure consistent visual identity across all your materials.',
    },
    10: {
      question: 'Does Veeso include image editing?',
      answer:
        'Yes. In addition to generating structured layouts, Veeso allows you to edit and refine images within your designs, keeping everything in one workflow.',
    },
    11: {
      question: 'How fast can I create a design using Veeso?',
      answer:
        'Most users can turn raw content into a polished, export-ready design in minutes. Veeso reduces formatting and layout time by automating structure and visual hierarchy.',
    },
    12: {
      question: 'Is Veeso free to use?',
      answer:
        'Yes. Veeso offers a free plan that includes daily refresh credits so you can explore and create without any upfront cost. You can upgrade to paid plans for more credits and advanced features.',
    },
    title: 'FAQ',
  },
  roles: {
    heading_1: 'STOP WAITING FOR DESIGN',
    heading_2: 'START GENERATING AT SCALE',
    description:
      'Turn your next piece of copy into production-ready visuals in 60 seconds, batch generation, fully editable, no design skills required.',
    cta: 'DESIGN NOW',
  },
  footer: {
    sr_only: 'Footer',
    col: {
      design_tools: 'Design Tools',
      resources: 'Resources',
      company: 'Company',
      connect: 'Connect',
    },
    link: {
      help: 'Help',
      solutions: 'Solutions',
      tools: 'Tools',
      learn: 'Learn',
      blog: 'Blog',
      spotlight: 'Spotlight',
      changelog: 'Changelog',
      affiliates: 'Affiliates',
      about: 'About',
      contact: 'Contact',
      terms: 'Terms',
      privacy: 'Privacy',
      cookie_policy: 'Cookie Policy',
      x: 'X',
      linkedin: 'LinkedIn',
      discord: 'Discord',
    },
    tooltip: {
      coming_soon: 'Coming soon',
    },
    copyright: '© {{year}} Veeso AI.',
  },
};
